module.exports = __webpack_public_path__ + "media/images/ln-img5-79a16b79f477bcd5a742fe1e73b27645.png";